import * as React from 'react';
import { IListItem } from '@nkr/models/index';
import { DashSelfServeReconciliationMatchType } from '@nkr/enums/index';
import { Badge, Button, Col, Label, Panel, PanelGroup, Well } from 'react-bootstrap';
import { IExtendedReconciliationItem } from './models';
import { MatchListWrapper, RowWrapper } from './styles';
import AddUpdateEntry from './add-update-entry';

interface IProps {
    data: IExtendedReconciliationItem[],
    closedLoopManualConfirmTypes: IListItem[],
    onShowHideUpdate: (index: number, matchId: number, show: boolean) => void,
    onUpdate: (index: number, matchId: number, firstName: string, lastName: string, birthDate: string, transplantDate: string, donationType: number) => void,
    onShowHideNewEntry: (index: number, show: boolean) => void,
    onCreateNewEntry: (index: number, firstName: string, lastName: string, birthDate: string, transplantDate: string, donationType: number) => void
}

class PendingItems extends React.Component<IProps, {}> {
    render = () => {
        const exactMatchCount = this.props.data.filter(x => x.matches.filter(x => x.matchType == DashSelfServeReconciliationMatchType.Exact).length > 0).length;
        const partialMatchCount = this.props.data.filter(x => x.matches.filter(x => x.matchType == DashSelfServeReconciliationMatchType.Partial).length > 0).length;
        const noMatchCount = this.props.data.filter(x => x.matches.length == 0).length;

        return (
            <Panel>
                <Panel.Heading style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div>Pending Items</div>
                    <div>
                        <Badge>{exactMatchCount}</Badge> - exact match(es)&nbsp;&nbsp;<Badge>{partialMatchCount}</Badge> - partial match(es)&nbsp;&nbsp;<Badge>{noMatchCount}</Badge> - no match(es)
                    </div>
                </Panel.Heading>
                <Panel.Body>
                    {this.props.data.length == 0 && (
                        <>There are no pending items...</>
                    )}

                    <PanelGroup style={{ marginBottom: 0 }}>
                        {this.props.data.map(item => {
                            let matchCount = item.matches.length;
                            let exactMatchList = item.matches.filter(x => x.matchType == DashSelfServeReconciliationMatchType.Exact);
                            let exactMatchCount = exactMatchList.length;
                            let exactMatchWithoutDonationTypeCount = exactMatchList.filter(x => x.donationType == 0).length;
                            let isOnlyExactMatch = matchCount == exactMatchCount && matchCount > 0;

                            let bsStyle = 'info';

                            if (matchCount == 0) {
                                bsStyle = 'warning';
                            } else {
                                if (isOnlyExactMatch) {
                                    if (exactMatchWithoutDonationTypeCount > 0) {
                                        bsStyle = 'info';
                                    } else {
                                        bsStyle = 'success';
                                    }
                                } else {
                                }
                            }

                            return (
                                <Panel bsStyle={bsStyle}>
                                    <Panel.Heading style={{ padding: '5px 15px' }}>
                                        <strong>File Data:</strong> {item.firstName} {item.lastName} &nbsp;/&nbsp; Birth Date: {item.birthDate} &nbsp;/&nbsp; Donation Date: {item.transplantDate}
                                    </Panel.Heading>
                                    <Panel.Body>
                                        <MatchListWrapper>
                                            {item.matches.map((match, matchIndex) => {
                                                let isExactMatch = match.matchType == DashSelfServeReconciliationMatchType.Exact;

                                                return (
                                                    <div className='match-row' key={`item-${item.index}-match-${matchIndex}`}>
                                                        <div key={'match-' + match.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                            <div>
                                                                {match.matchType == DashSelfServeReconciliationMatchType.Exact ? 'Exact Match' : 'Partial Match'}
                                                            </div>
                                                            <div>
                                                                {match.firstName} {match.lastName}<br />
                                                                DOB: {match.birthDate}<br />
                                                                Donation Date: {match.transplantDate ? match.transplantDate : '[not found]'}<br />
                                                                Donation Type: {match.donationTypeDescription == '0' ? '[unknown]' : match.donationTypeDescription}
                                                            </div>
                                                            <div className='text-right'>
                                                                <Button bsStyle={bsStyle} bsSize='small' disabled={(!match.selected && item.newEntry == false) == false} onClick={() => this.props.onShowHideUpdate(item.index, match.id, true)}>{isExactMatch ? 'Update Record' : 'Yes, it\'s this one'}</Button>
                                                            </div>
                                                        </div>

                                                        {match.selected && (
                                                            <div style={{ padding: 10 }}>
                                                                <Well style={{ marginBottom: 0 }}>
                                                                    <AddUpdateEntry
                                                                        firstName={item.firstName}
                                                                        lastName={item.lastName}
                                                                        birthDate={item.birthDate}
                                                                        transplantDate={item.transplantDate}
                                                                        donationTypes={this.props.closedLoopManualConfirmTypes}
                                                                        isUpdate={true}
                                                                        onCreateUpdate={(firstName, lastName, birthDate, transplantDate, donationType) =>
                                                                            this.props.onUpdate(item.index, match.id, firstName, lastName, birthDate, transplantDate, donationType)
                                                                        }
                                                                        onCancel={() => this.props.onShowHideUpdate(item.index, match.id, false)}
                                                                    />
                                                                </Well>
                                                            </div>
                                                        )}
                                                    </div>
                                                );
                                            })}
                                        </MatchListWrapper>

                                        <div style={{ marginTop: 10 }}>
                                            {(!item.newEntry && (!item.newEntry && item.matches.filter(x => x.selected).length == 0)) && (
                                                <div style={{ textAlign: 'center' }}>
                                                    <Button onClick={() => this.props.onShowHideNewEntry(item.index, true)}>
                                                        Not listed, create new entry
                                                    </Button>
                                                </div>
                                            )}

                                            {item.newEntry && (
                                                <Well>
                                                    <AddUpdateEntry
                                                        firstName={item.firstName}
                                                        lastName={item.lastName}
                                                        birthDate={item.birthDate}
                                                        transplantDate={item.transplantDate}
                                                        donationTypes={this.props.closedLoopManualConfirmTypes}
                                                        isUpdate={false}
                                                        onCreateUpdate={(firstName, lastName, birthDate, transplantDate, donationType) =>
                                                            this.props.onCreateNewEntry(item.index, firstName, lastName, birthDate, transplantDate, donationType)
                                                        }
                                                        onCancel={() => this.props.onShowHideNewEntry(item.index, false)}
                                                    />
                                                </Well>
                                            )}
                                        </div>
                                    </Panel.Body>
                                </Panel>
                            );
                        })}
                    </PanelGroup>
                </Panel.Body>
            </Panel>
        );
    }
}

export default PendingItems;